export function useControlReload(
    events: any,
    blueprintName: string,
    level: number,
    parentName: string = null,
    index: number = null
)
{
    const eventName = parentName != null && parentName !== ''
        ? `reload-control-${level}-${parentName}-${index}-${blueprintName}`
        : `reload-control-${level}-${blueprintName}`;

    const eventOn = (reloadFunction?: () => Promise<void> | void) =>
    {
        events.$on(eventName, reloadFunction);
    };

    const eventOff = () =>
    {
        events.$off(eventName);
    };

    const emitReload = (tableRowIndex: number | null = null) =>
    {
        events.$emit(eventName, tableRowIndex);
    };

    return {
        eventOn,
        eventOff,
        emitReload
    };
}
